import * as THREE from "three";
import Experience from "../Experience.js";

export default class Raycaster {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.camera = this.experience.camera;
    this.controls = this.camera.controls;
    this.resources = this.experience.resources;
    this.sceneObjects = [];
    this.currentSelectedObject = [];
    this.interactions = this.experience.interactions;

    // // Wait for resources
    this.resources.on("ready", () => {
      const { lamp, lightswitch, mug } = this.experience.world;
      this.sceneObjects.push(lamp.model, lightswitch.model, mug.model);
    });

    this.x = 0.0002;
    this.y = 0.0002;

    this.setRaycaster();
    this.setGeometry();
    this.setMaterial();
    this.setMesh();
  }

  setRaycaster() {
    this.cameraDirection = new THREE.Vector3();
    this.raycaster = new THREE.Raycaster();
  }

  update() {
    const getDirection = this.controls.getDirection();
    getDirection(this.cameraDirection);

    this.raycaster.set(
      this.controls.getObject().position,
      this.cameraDirection
    );
    this.controls.getDirection(this.cameraDirection);

    this.intersects = this.raycaster.intersectObjects(this.sceneObjects);

    this.intersects.map((intersect) => {
      this.currentSelectedObject = intersect.object;
    });

    this.intersects.length
      ? this.material.color.set("blue")
      : this.material.color.set("white");
  }

  setGeometry() {
    let points = [];
    let { x, y } = this;

    points.push(new THREE.Vector3(0, y, 0));
    points.push(new THREE.Vector3(0, -y, 0));
    points.push(new THREE.Vector3(0, 0, 0));
    points.push(new THREE.Vector3(x, 0, 0));
    points.push(new THREE.Vector3(-x, 0, 0));

    this.geometry = new THREE.BufferGeometry().setFromPoints(points);
  }

  setMaterial() {
    this.material = new THREE.LineBasicMaterial({ color: "white" });
  }

  setMesh() {
    this.mesh = new THREE.Line(this.geometry, this.material);

    // place it in the center
    this.mesh.position.y = 0;
    this.mesh.position.x = 0;
    this.mesh.position.z = -0.2;

    this.camera.instance.add(this.mesh);
  }
}
